namespace GeniuzPOS.AdvPromo {
    export namespace PsAdvPromoItem9Service {
        export const baseUrl = 'AdvPromo/PsAdvPromoItem9';

        export declare function Create(request: Serenity.SaveRequest<PsAdvPromoItem9Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsAdvPromoItem9Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsAdvPromoItem9Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsAdvPromoItem9Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsAdvPromoItem9/Create",
            Update = "AdvPromo/PsAdvPromoItem9/Update",
            Delete = "AdvPromo/PsAdvPromoItem9/Delete",
            Retrieve = "AdvPromo/PsAdvPromoItem9/Retrieve",
            List = "AdvPromo/PsAdvPromoItem9/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsAdvPromoItem9Service)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
